import { default as processClassNames } from 'classnames'
import { healthPath, helloBabyPath, indexPath, storePath } from 'lib/urls'
import ToggleNav from '../ToggleNav'
import css from '../../global-nav.scss'

interface HomePageSiteNavSectionProps {
  activeNavItem?: string
  classNames: any
  handleToggleNav: () => void
  trackClick: (eventCta: string) => void
}

const HomePageSiteNavSection = ({
  activeNavItem,
  classNames,
  handleToggleNav,
  trackClick,
}: HomePageSiteNavSectionProps) => (
  <ul className={processClassNames(classNames)}>
    <ToggleNav onClick={handleToggleNav} />
    <li
      className={processClassNames(
        css.fullNavOnly,
        css.navLink,
        css.registryLink,
        activeNavItem === 'Registry' && css.registryActive
      )}
    >
      <a href={indexPath} onClick={() => trackClick('Registry')}>
        Registry
      </a>
    </li>
    <li
      className={processClassNames(
        css.fullNavOnly,
        css.navLink,
        css.storeLink,
        activeNavItem === 'Store' && css.storeActive
      )}
    >
      <a href={storePath} onClick={() => trackClick('Shop')}>
        Shop
      </a>
    </li>
    <li
      className={processClassNames(
        css.fullNavOnly,
        css.navLink,
        css.guidesLink,
        activeNavItem === 'Guides' && css.guidesActive
      )}
    >
      <a href={helloBabyPath} onClick={() => trackClick('Guides')}>
        Guides
      </a>
    </li>
    <li className={processClassNames(css.fullNavOnly, css.navLink)}>
      <a href={healthPath} onClick={() => trackClick('Health')} target="_blank">
        Health
      </a>
    </li>
  </ul>
)

export default HomePageSiteNavSection
